module.exports = __webpack_public_path__ + "img/3.9769d17c.jpg";